import i18next from "src/i18n/config";
import { z } from "zod";

const message = {
    deviceSerial: i18next.t("pages:adminLicensesPage.validation.deviceSerial"),
    email: i18next.t("pages:adminLicensesPage.validation.email"),
    grantCount: i18next.t("pages:adminLicensesPage.validation.grantCount"),
    groupId: i18next.t("pages:adminLicensesPage.validation.groupId"),
    licenseKey: i18next.t("pages:adminLicensesPage.validation.licenseKey"),
    reason: i18next.t("pages:adminLicensesPage.validation.reason"),
};

const asTrimmedString = (value: unknown) => (value === null || value === undefined ? "" : String(value).trim());

const requiredText = (error: string) => z.unknown().transform(asTrimmedString).pipe(z.string().min(1, error));

const requiredDigits = (error: string) => z.unknown().transform(asTrimmedString).pipe(z.string().regex(/^\d+$/, error));

const licenseKey = requiredText(message.licenseKey);
const groupId = requiredDigits(message.groupId);
const reason = requiredText(message.reason);

export const grantSchema = z.object({
    userEmail: z.unknown().transform(asTrimmedString).pipe(z.email(message.email)),
    groupId,
    grantCount: z
        .unknown()
        .transform(asTrimmedString)
        .pipe(z.string().regex(/^[1-9]\d*$/, message.grantCount)),
});
export type GrantFormValues = z.infer<typeof grantSchema>;

export const moveSchema = z.object({ licenseKey, groupId });
export type MoveFormValues = z.infer<typeof moveSchema>;

export const revokeSchema = z.object({ licenseKey, reason });
export type RevokeFormValues = z.infer<typeof revokeSchema>;

export const reviveSchema = z.object({ licenseKey, groupId, reason });
export type ReviveFormValues = z.infer<typeof reviveSchema>;

export const attachSchema = z.object({
    licenseKey,
    deviceSerial: requiredText(message.deviceSerial),
});
export type AttachFormValues = z.infer<typeof attachSchema>;

export const detachSchema = z.object({ licenseKey, reason });
export type DetachFormValues = z.infer<typeof detachSchema>;

export const inspectSchema = z.object({ licenseKey });
export type InspectFormValues = z.infer<typeof inspectSchema>;

export const deleteSchema = z.object({ licenseKey, reason });
export type DeleteFormValues = z.infer<typeof deleteSchema>;
